import {
  TextArea,
  type TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";

interface YourFeedbackProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  showStarLabel?: boolean;
  disable?: boolean;
  iconSrc?: string;
  rows?: number;
  maxLength?: number;
  placeholder?: string;
}

export const YourFeedback: React.FC<YourFeedbackProps> = ({
  label = "Default Label",
  value,
  onChange,
  disable = false,
  iconSrc,
  rows = 5,
  maxLength = 500,
  placeholder = "",
}) => {
  const handleChange = (e: TextAreaChangeEvent) => {
    const raw = String(e.value ?? "");
    onChange(raw);
  };

  return (
    <div className="relative w-full numeric-textbox">
      <label
        className={`input-label-textarea gx-font-semibold ${value ? "floating" : ""}`}
      >
        {label}
        
      </label>

      <div className="input-label-textareas">
        {iconSrc && (
          <img
            src={iconSrc}
            alt="icon"
            className="absolute left-3 top-3 w-4 h-4 opacity-80"
          />
        )}

        <TextArea
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          rows={rows}
          autoSize={false}
          disabled={disable}
          placeholder={placeholder}
          className="gx-textbox-css custom-textarea-scroll gx-font-semibold ps-8"
        />
      </div>
    </div>
  );
};
